import React from "react";
import {
  SubTitleTab,
  TitleTab,
} from "../../../../../../component/page-components";
import { Col, Input, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import MSSAddDayOff from "../../../../../../component/mss/day-off/add-day-off";
import DropdownSearchCountry from "../../../../../../component/dropdown-search/dds-region/dds-country";
import DropdownSearchProvince from "../../../../../../component/dropdown-search/dds-region/dds-province";
import DropdownSearchDistrict from "../../../../../../component/dropdown-search/dds-region/dds-district";
import DropdownSearchSubDistrict from "../../../../../../component/dropdown-search/dds-region/dds-subdistrict";
import DropdownSearchUrbanVillage from "../../../../../../component/dropdown-search/dds-region/dds-urban-village";
import DropdownSearchPostalCode from "../../../../../../component/dropdown-search/dds-region/dds-postal-code";
import onKeyPressNumber from "../../../../../../util/onKeyPressNumber";

const FormAddressOutsource = ({
  err,
  error,
  countryId,
  setCountryId,
  provinceId,
  setProvinceId,
  districtId,
  setDistrictId,
  subDistrictId,
  setSubDistrictId,
  urbanVillageId,
  setUrbanVillageId,
  postalCodeId,
  setPostalCodeId,
  valueDayOff,
  setValueDayOff,
  handleFormInput,
  FormInput,
  handleFormInputShiftStart,
  FormInputShiftStart,
  handleFormInputShiftEnd,
  FormInputShiftEnd,
  FormError,
  handleBlur,
}) => {
  return (
    <div className="columns">
      <TitleTab title="Address" />

      <div className="container-field">
        <SubTitleTab title="Country" />
        <DropdownSearchCountry
          placeholder="Select Country"
          setValueDDS={setCountryId}
          valueDDS={countryId}
        />
        <div className="text-red-100">{err ? err : error?.country}</div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Province" />
        <DropdownSearchProvince
          placeholder="Select Province"
          countryId={countryId}
          setValueDDS={setProvinceId}
          valueDDS={provinceId}
        />
        <div className="text-red-100">{err ? err : error?.province}</div>
      </div>

      <div className="container-field">
        <SubTitleTab title="District" />
        <DropdownSearchDistrict
          placeholder="Select District"
          countryId={countryId}
          provinceId={provinceId}
          setValueDDS={setDistrictId}
          valueDDS={districtId}
        />

        <div className="text-red-100">{err ? err : error?.district}</div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Sub District" />
        <DropdownSearchSubDistrict
          placeholder="Select Sub District"
          countryId={countryId}
          districtId={districtId}
          setValueDDS={setSubDistrictId}
          valueDDS={subDistrictId}
        />

        <div className="text-red-100">{err ? err : error?.sub_district}</div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Urban Village" />
        <DropdownSearchUrbanVillage
          placeholder="Select Urban Village"
          countryId={countryId}
          subDistrictId={subDistrictId}
          setValueDDS={setUrbanVillageId}
          valueDDS={urbanVillageId}
        />

        <div className="text-red-100">{err ? err : error?.urban_village}</div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Address" />
        <TextArea
          style={{ width: 500, resize: "none" }}
          size="large"
          rows={4}
          maxLength={100}
          placeholder="Type Address"
          onChange={(evt) => {
            handleFormInput(evt.target.value, "address");
          }}
          value={FormInput?.address}
          status={FormError?.address ? "error" : null}
        />
        <div className="text-red-100">
          {FormError?.address ? FormError?.address : false}
        </div>
      </div>

      <div className="container-field">
        <div className="w-[500px] flex gap-[16px]">
          <div className="w-[200]">
            <SubTitleTab title="Neighbourhood (Optional)" />
            <Input
              size="large"
              placeholder="Type Neighbourhood"
              onKeyPress={(e) => onKeyPressNumber(e)}
              onChange={(evt) => {
                handleFormInput(evt.target.value, "neighbourhood");
              }}
              value={FormInput?.neighbourhood}
              status={error?.neighbourhood ? "error" : null}
              maxLength={3}
            />
            <div className="text-red-100">
              {err ? err : error?.neighbourhood}
            </div>
          </div>
          <div className="w-[200]">
            <SubTitleTab title="Hamlet (Optional)" />
            <Input
              size="large"
              placeholder="Type Hamlet"
              onKeyPress={(e) => onKeyPressNumber(e)}
              onChange={(evt) => {
                handleFormInput(evt.target.value, "hamlet");
              }}
              value={FormInput?.hamlet}
              status={error?.hamlet ? "error" : null}
              maxLength={3}
            />
            <div className="text-red-100">{err ? err : error?.hamlet}</div>
          </div>
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Postal Code" />
        <DropdownSearchPostalCode
          placeholder="Select Postal Code"
          urbanVillageId={urbanVillageId}
          setValueDDS={setPostalCodeId}
          valueDDS={postalCodeId}
        />

        <div className="text-red-100">{err ? err : error?.postal_code}</div>
      </div>

      <TitleTab title="Working Hours" />

      <div className="container-field">
        <SubTitleTab title="Shift Start" />
        <div className=" w-2/6 h-[47px]">
          <Row>
            <Col span={10} className="pr-2 ">
              <Input
                style={{ height: "47px" }}
                placeholder="00"
                maxLength={2}
                onKeyPress={(e) => onKeyPressNumber(e)}
                onChange={(evt) => {
                  handleFormInputShiftStart(
                    evt.target.value,
                    "shift_start_hour"
                  );
                }}
                onBlur={()=>handleBlur(FormInputShiftStart?.shift_start_hour,"shift_start_hour", true)}
                value={FormInputShiftStart?.shift_start_hour}
                status={FormError?.shift_start_hour ? "error" : null}
              />
              {/* {FormError?.shift_start_hour ? (
                <p className="mb-8 text-red-100">
                  {FormError?.shift_start_hour}
                </p>
              ) : (
                false
              )} */}
            </Col>
            <Col>
              <p className="mr-1 text-2xl font-bold font-roboto text-black-100">
                :
              </p>
            </Col>
            <Col span={10}>
              <Input
                style={{ height: "47px" }}
                placeholder="00"
                maxLength={2}
                onKeyPress={(e) => onKeyPressNumber(e)}
                onChange={(evt) => {
                  handleFormInputShiftStart(
                    evt.target.value,
                    "shift_start_minute"
                  );
                }}
                onBlur={()=>handleBlur(FormInputShiftStart?.shift_start_minute,"shift_start_minute", true)}
                value={FormInputShiftStart?.shift_start_minute}
                status={FormError?.shift_start_minute ? "error" : null}
              />
              {/* {FormError?.shift_start_minute ? (
                <p className="mb-8 text-red-100">
                  {FormError?.shift_start_minute}
                </p>
              ) : (
                false
              )} */}
            </Col>
          </Row>
              {FormError?.shift_start_minute || FormError?.shift_start_hour? (
                <p className="mb-8 text-red-100">
                  This field is required
                </p>
              ) : (
                false
              )}
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Shift End" />
        <div className=" w-2/6 h-[47px]">
          <Row>
            <Col span={10} className="pr-2 ">
              <Input
                placeholder="00"
                style={{ height: "47px" }}
                maxLength={2}
                onKeyPress={(e) => onKeyPressNumber(e)}
                onChange={(evt) => {
                  handleFormInputShiftEnd(evt.target.value, "shift_end_hour");
                }}
                onBlur={()=>handleBlur(FormInputShiftEnd?.shift_end_hour,"shift_end_hour", false)}
                value={FormInputShiftEnd?.shift_end_hour}
                status={FormError?.shift_end_hour ? "error" : null}
              />
              {/* {FormError?.shift_end_hour ? (
                <p className="mb-8 text-red-100">{FormError?.shift_end_hour}</p>
              ) : (
                false
              )} */}
            </Col>
            <Col>
              <p className="mr-1 text-2xl font-bold font-roboto text-black-100">
                :
              </p>
            </Col>
            <Col span={10}>
              <Input
                placeholder="00"
                style={{ height: "47px" }}
                maxLength={2}
                onKeyPress={(e) => onKeyPressNumber(e)}
                onChange={(evt) => {
                  handleFormInputShiftEnd(evt.target.value, "shift_end_minute");
                }}
                onBlur={()=>handleBlur(FormInputShiftEnd?.shift_end_minute,"shift_end_minute", false)}
                value={FormInputShiftEnd?.shift_end_minute}
                status={FormError?.shift_end_minute ? "error" : null}
              />
              {/* {FormError?.shift_end_minute ? (
                <p className="mb-8 text-red-100">
                  {FormError?.shift_end_minute}
                </p>
              ) : (
                false
              )} */}
            </Col>
          </Row>
          {FormError?.shift_end_minute || FormError?.shift_end_hour ? (
                <p className="mb-8 text-red-100">
                  This field is required
                </p>
              ) : (
                false
              )}
        </div>
        <div className="text-red-100">
          {err
            ? err
            : error?.shift_end_hour
            ? error?.shift_end_hour
            : error?.shift_end_minute}
        </div>
      </div>

      <div className="container-field">
        <SubTitleTab title="Day Off" />
        <MSSAddDayOff setVal={setValueDayOff} val={valueDayOff} />
        <div className="text-red-100">{err ? err : error?.day_off}</div>
      </div>
      
      <div className='container-field'>
        <SubTitleTab title="Daily Salary" />
        <Input
          size="large"
          placeholder="Type Daily Salary"
          onKeyPress={(e) => onKeyPressNumber(e)}
          onChange={(evt) => {
            handleFormInput(evt.target.value, "daily_salary");
          }}
          value={FormInput?.daily_salary}
          addonBefore="IDR"
          // maxLength={13}
          status={FormError?.daily_salary ? "error" : null}
        />
        <div className="text-red-100">
          {FormError?.daily_salary
            ? FormError?.daily_salary
            : false}
        </div>
      </div>
      <div className='container-field'>
        <SubTitleTab title="Hourly Salary" />
        <Input
          size="large"
          placeholder="Type Hourly Salary"
          value={FormInput?.hourly_salary}
          addonBefore="IDR"
          disabled
        />
      </div>
    </div>
    
  );
};

export default FormAddressOutsource;
